import { CurrencyModel } from '~/api/currencies/currency.model';

let registry: ReadonlyMap<number, CurrencyModel> = new Map();
let defaultCurrency: CurrencyModel | undefined;

export const setCurrencyRegistry = (list: CurrencyModel[]) => {
  registry = new Map(list.map((currency) => [currency.id, currency]));
  defaultCurrency = list.find((currency) => currency.isDefault) ?? list[0];
};

export const getCurrencyById = (id: number | undefined): CurrencyModel | undefined => {
  if (id === undefined) {
    return undefined;
  }

  return registry.get(id);
};

export const getDefaultCurrency = (): CurrencyModel | undefined => defaultCurrency;
